import { Attribute, Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { Enum } from './enum.resource';
import { Ussdmenus } from './ussd-menu.ressource';
import { Ussdoptions } from './ussd-option.resource';
import { Translatable } from 'src/app/translation/translatable';
import { Pack } from './pack.resource';
import { ResourceConfig } from 'src/app/resources/resources-interfaces/resource-config';

@Resource({
  type: 'ussdnodes',
})
export class Ussdnodes extends AtomResource {
  @Attribute() text?: Translatable;
  @Attribute() title?: Translatable;
  @Attribute() action?: Enum | string;
  @Attribute() order?: number;

  @Relationship() parentussdnode?: Ussdnodes | null;
  @Relationship() ussdmenu?: Ussdmenus;
  @Relationship() pack?: Pack;
}

export class UssdnodesConfig implements ResourceConfig {
  resource = Ussdnodes;
  resourceName = 'USSD Node';
  resourceKey = 'ussdnodes';
  detail = {
    header: {
      icon: 'list',
      title: [
        {
          path: ['text'],
          translatable: true,
        },
      ],
      id: true,
    },
  };
  wizard = {
    noSummary: true,
    tabs: [
      {
        title: 'Ussd Node',
        formGroup: 'ussdnode',
        list: [
          {
            type: 'text',
            title: 'Text',
            formControl: 'text',
            translatable: true,
            required: true,
          },
          {
            type: 'text',
            title: 'Title',
            formControl: 'title',
            translatable: true,
            required: true,
          },
          {
            type: 'enum',
            title: 'Action',
            formControl: 'action',
            APIKey: 'action',
            fieldKey: 'action',
            required: true,
            mulitple: false,
          },
          {
            type: 'text',
            title: 'Order',
            formControl: 'order',
            translatable: false,
            required: true,
          },
          // {
          //   type: 'resource',
          //   title: 'Platform',
          //   formControl: 'platform',
          //   // search: new PlatformConfig(this.atom),
          //   required: true,
          //   check: 'equal',
          // },
        ],
      },
    ],
  };
}
